module.exports = __webpack_public_path__ + "static/media/lab.e6fdf897.svg";